var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { computeTicks, dataBounds, defaultLayout } from '../../chartPrimitives';
import { flattenSeriesData } from './series';
import { num } from '../../helpers';
export function buildChartContext(props, series) {
    var _a;
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 150);
    var minimal = props.minimalAxes === true;
    var showLegend = props.showLegend !== false && !minimal;
    var padding = minimal ? 4 : 30;
    var legendRows = showLegend ? series.length : 0;
    var legendH = legendRows > 0 ? legendRows * 18 + 8 : 0;
    var layout = defaultLayout(width, height, padding, legendH);
    var minY = typeof props.minY === 'number' ? props.minY : undefined;
    var maxY = typeof props.maxY === 'number' ? props.maxY : undefined;
    var bounds = dataBounds(flattenSeriesData(series), minY, maxY);
    var yTicks = computeTicks(bounds.min, bounds.max, num(props, 'tickCount', 5));
    var categories = (_a = props.categories) !== null && _a !== void 0 ? _a : Array.from({ length: Math.max.apply(Math, __spreadArray(__spreadArray([], __read(series.map(function (s) { return s.data.length; })), false), [1], false)) }, function (_, i) { return String(i + 1); });
    return { width: width, height: height, layout: layout, bounds: bounds, yTicks: yTicks, categories: categories, series: series };
}
